import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-ki-fehler',
  imports: [MatButtonModule, MatIconModule, TranslatePipe],
  templateUrl: './ki-fehler.component.html',
  styleUrl: './ki-fehler.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiFehlerComponent {
  readonly text = input.required<string>();
  /** Aus, wenn ein neuer Versuch nichts ändert (z. B. fehlende Schreibrechte). */
  readonly erneutAnbieten = input(true);
  readonly erneut = output<void>();
}
